import type { HTMLAttributes } from 'react';
import styles from './Paper.module.css';

type Tag = 'div' | 'section' | 'article' | 'aside' | 'form';

interface Props extends HTMLAttributes<HTMLElement> {
  as?: Tag;
  padded?: boolean;
}

export function Paper({ as: Component = 'div', padded = true, className, ...rest }: Props) {
  return (
    <Component className={[styles.paper, padded && styles.padded, className].filter(Boolean).join(' ')} {...rest} />
  );
}
